<template>
  <form class="popup popup--visible" novalidate @submit.prevent="handleSubmit">
    <div class="popup__bg" @click="closePopup"></div>
    <div class="popup__container">
      <div class="popup__content">
        <div class="popup__header">
          <p class="h2-like">{{ t("products.form.accountingSoftwareConfiguration.addItemCode") }}</p>
        </div>
        <div class="popup__block">
          <FormInput
            v-model="value"
            :ref="addFormInputRef"
            :label="t('products.form.accountingSoftwareConfiguration.itemCode')"
            name="new-item-code-value"
            type="text"
            @validated="handleValidation"
          />
          <p v-if="errorMessage" class="form__error-message">{{ errorMessage }}</p>
          <div class="form__submit">
            <button class="btn btn--fullscreen" type="submit">{{ t('global.add') }}</button>
            <button class="btn btn--fullscreen btn--red" type="button" @click="closePopup">{{ t('global.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script lang="ts" setup>
import { ref } from "vue"
import { useI18n } from "vue3-i18n"
import { notifyError, notifySuccess } from "@/notify"
import { Status } from "@/validation"
import FormInput from "@/components/forms/FormInput.vue"
import { useAccountingSoftwareCodeService } from "@/inversify.config"

// eslint-disable-next-line no-undef
const emit = defineEmits<{
  (event: "closePopup"): void
  (event: "codeCreated", code: { value: string }): void
}>()

const { t } = useI18n()
const accountingSoftwareCodeService = useAccountingSoftwareCodeService()

const value = ref("")
const errorMessage = ref("")
const formInputs = ref<(typeof FormInput)[]>([])
const inputValidationStatuses: any = {}

function addFormInputRef(ref: typeof FormInput) {
  if (!formInputs.value.includes(ref))
    formInputs.value.push(ref)
}

async function handleValidation(name: string, validationStatus: Status) {
  inputValidationStatuses[name] = validationStatus.valid
}

async function handleSubmit() {
  formInputs.value.forEach((x: typeof FormInput) => x?.validateInput())

  if (Object.values(inputValidationStatuses).some(x => x === false)) {
    notifyError(t('global.formErrorNotification'))
    return
  }

  errorMessage.value = ""
  const created = await accountingSoftwareCodeService.createItemCode(value.value)
  if (created?.value) {
    notifySuccess(t('products.form.accountingSoftwareConfiguration.codeAdded'))
    emit("codeCreated", { value: created.value })
    closePopup()
    return
  }
  errorMessage.value = t('products.form.accountingSoftwareConfiguration.codeAlreadyExists')
}

function closePopup() {
  emit("closePopup")
}
</script>
